<template>
  <div class="hero" :class="`hero--${active}`">
    <div :class="`hero__bg-wrapper--1 hero__bg-wrapper--1--${active}`"></div>
    <div
      :class="`hero__bg-wrapper--2 hero__bg-wrapper--2--${active}`"
      style=""
      :style="``"
    ></div>
    <div class="hero-bg-left">
      <ul class="nav nav-tabs rounded-top border-bottom-0">
        <li
          class="nav-item d-flex flex-column align-items-center"
          :id="`nav-item-${active}`"
          v-for="(item, index) in dataModel"
          :key="item"
          :class="index <= 3 ? 'd-flex' : 'd-none'"
        >
          <a
            :class="
              active == index
                ? 'nav-link active d-none d-md-flex flex-column align-items-end text-uppercase'
                : 'nav-link  d-none d-md-flex flex-column align-items-end text-uppercase'
            "
            data-bs-toggle="tab"
            :data-id="index"
            :id="index"
            @click="
              getIndex(index);
              bottles($event);
              bgAnimation($event);
            "
            :href="'#retailer-' + index"
          >
            <div
              v-html="dataModel[1].ui.retailers[index].title"
              class="d-flex"
            ></div>
          </a>
          <!-- get-mobile-hero -->
          <a
            :class="
              active == index
                ? 'nav-link active d-flex d-md-none flex-column align-items-end text-uppercase'
                : 'nav-link d-flex d-md-none flex-column align-items-end text-uppercase'
            "
            data-bs-toggle="tab"
            :data-id="index"
            @click="
              getIndex(index);
              bottles($event);
              bgAnimation($event);
            "
            :href="'#retailer-' + index"
          >
            <div
              v-html="dataModel[1].ui.retailers[index].title"
              class="d-flex"
            ></div>
          </a>
        </li>
      </ul>
    </div>
    <div class="middle">
      <img
        :src="`${pre}For-the-crew.png`"
        style="height: 800px; z-index: 100; position: relative"
        class="hero-text-img"
      />
    </div>

    <div class="hero-bg-right">
      <img
        :src="`${pre}hero/bottle-1.png`"
        class="bottles bottle-1"
        style="z-index: 5; opacity: 1"
      />
    </div>
    <div class="hero-bg-right">
      <img
        :src="`${pre}hero/bottle-2.png`"
        class="bottles bottle-2"
        style="z-index: 5; opacity: 1"
      />
    </div>
    <div class="hero-bg-right">
      <img
        :src="`${pre}hero/bottle-3.png`"
        class="bottles bottle-3"
        style="z-index: 5; opacity: 1"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      priceColor: "#000000",
      isVisible: this.next,
      active: 1,
      bgActiveSlot: 1,
      init: false,
    };
  },
  methods: {
    //get index of active product and pass it over to app
    getIndex(index) {
      this.active = index;
      this.$emit("active", index);
    },
    //make tab active
    apiRefresh() {
      this.active = 1;
    },
    dragScroll() {
      const slider = document.querySelector(".nav-tabs");
      let mouseDown = false;
      let startX, scrollLeft;
      let startDragging = function (e) {
        mouseDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };
      let stopDragging = function (event) {
        mouseDown = false;
      };
      slider.addEventListener("mousemove", (e) => {
        e.preventDefault();
        if (!mouseDown) {
          return;
        }
        const x = e.pageX - slider.offsetLeft;
        const scroll = x - startX;
        slider.scrollLeft = scrollLeft - scroll;
      });
      // Add the event listeners
      slider.addEventListener("mousedown", startDragging, false);
      slider.addEventListener("mouseup", stopDragging, false);
      slider.addEventListener("mouseleave", stopDragging, false);
    },

    //animate bottle
    bottles(e) {
      var dId = e.currentTarget.getAttribute("data-id");
      $(".nav-link").css({ pointerEvents: "none" });
      gsap.to(".bottles", {
        y: -1200,
        duration: 1,
        onComplete: () => {
          gsap.to(`.bottle-${dId}`, {
            duration: 1,
            opacity: 1,
            y: 0,
          });
          $(".nav-link").css({ pointerEvents: "all" });
        },
      });
    },
    bgAnimation(e) {
      var ref = this;
      var dId = 1;
      if (ref.init) {
        dId = e.currentTarget.getAttribute("data-id");
      }
      if (ref.bgActiveSlot == 1) {
        ref.bgActiveSlot = 2;
        $(".hero__bg-wrapper--2").css({
          background: `url(hero/hero-img-${ref.active}.jpg)`,
          backgroundPosition: () => {
            if (dId == 2 && window.innerWidth < 700) {
              return "32% center";
            } else if (dId == 3 && window.innerWidth < 700) {
              return "62% center";
            } else {
              return "center";
            }
          },
          backgroundSize: "cover",
        });
        gsap.to(".hero__bg-wrapper--2", {
          opacity: 1,
          duration: 0.5,
        });
      } else {
        ref.bgActiveSlot = 1;
        $(".hero__bg-wrapper--1").css({
          background: `url(hero/hero-img-${ref.active}.jpg)`,
          backgroundPosition: () => {
            if (dId == 2 && window.innerWidth < 700) {
              return "32% center";
            } else if (dId == 3 && window.innerWidth < 700) {
              return "62% center";
            } else {
              return "center";
            }
          },
          backgroundSize: "cover",
        });
        gsap.to(".hero__bg-wrapper--2", {
          opacity: 0,
          duration: 0.5,
        });
      }
    },
  },
  //invoke on load
  mounted() {
    this.dragScroll();
    this.getIndex();
    this.apiRefresh();
    this.bgAnimation();
    this.init = true;
    gsap.set(".bottle-2, .bottle-3", {
      y: -1200,
      opacity: 0,
    });
  },
};
</script>

<script setup>
import dataModel from "../js/model.js";
import gsap from "gsap";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  }, 
  pre: {
    type: String,
    default: "1",
  }, 
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.hero__bg-wrapper--1 {
  background-position: center;
  background-size: cover;
  left: 0px;
  top: 0px;
  position: absolute;
  width: 100%;
  height: 100%;
}
.hero__bg-wrapper--2 {
  background-position: center;
  background-size: cover;
  left: 0px;
  top: 0px;
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}

.hero__bg-wrapper--1--3 {
  @media (max-width: 700px) {
    background-position: 62% center !important;
  }
}
.hero {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  margin-top: 85px;
  position: relative;
  height: 650px;
  background-position: center;
  // background-size: cover;
}
.hero--1 {
  background-size: 150%;
  background-position-x: right !important;
  background-position-y: bottom !important;
  @media (min-width: 1200px) {
    background-size: 135% !important;
  }
}
.hero-text-img {
  height: 800px;
}
// .nav-item:nth-child(1) {
//   -webkit-animation: pulse 3s linear infinite;
//   animation: pulse 3s linear infinite;
// }
// .nav-item {
//   opacity: 0;
//   transition: opacity 3s linear infinite;
// }

// .nav-item:nth-of-type(1) {
//   animation: pulse 1s linear infinite;
//   transition-delay: 1s;
// }

// .nav-item:nth-of-type(2) {
//   transition-delay: 2s;
//   animation: pulse 1s linear infinite;
// }

// .nav-item:nth-of-type(3) {
//   transition-delay: 3s;
//   animation: pulse 1s linear infinite;
// }

@media (max-width: 1200px) {
  .bottle-1,
  .bottle-2,
  .bottle-3 {
    right: 120px !important;
    z-index: -1;
  }
}
@media (max-width: 850px) {
  .hero-text-img {
    height: 600px !important;
  }
  // .hero--1 {
  //   background-size: 175%;
  //   background-position-x: -550px;
  // }
}
.hero-bg-left {
  @include flexbox();
}
.legal {
  width: 160px;
  margin-top: -25px;
  @media (max-width: 700px) {
    width: 120px;
  }
}
.bottles {
  position: absolute;
  top: 10;
  top: -60px;
  height: 115%;
  right: 220px;
  z-index: -1;
}
.title {
  font-family: termina, sans-serif;
  font-weight: 800;
  font-size: 50px;
  color: #ffffff;
  margin-top: 25px;
  line-height: 45px;
}
.subTitle {
  font-family: termina, sans-serif;
  font-weight: 100;
  color: #ffffffa4;
  margin-bottom: 20px;
}
.gold-border {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 15px;
  width: 100%;
  z-index: 10;
}
.buy-btn-hero {
  display: none;
  z-index: 5;
  position: relative;
}
div.inline-nav__text {
  font-size: 18px;
  line-height: 18px;
  font-weight: 400;
  letter-spacing: 1px;
  align-items: center;
}
.mob {
  display: none;
}
.desktop {
  @include flexbox();
  @include justify-content(center);
}
@media (max-width: 948px) {
  .title {
    font-size: 45px !important;
  }
  .bottles {
    right: 10px !important;
    z-index: -1;
  }
}
@media (max-width: 970px) {
  .hero--1 {
    background-size: 250% !important;
    background-position-x: center !important;
  }
}
.nav-link {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
}
.nav {
  @include flex-direction(column);
  position: absolute;
  left: -10px;
  top: 35%;
  width: 140px;
  z-index: 10;
}
.nav-tabs .nav-link {
  margin-left: -100px;
  min-height: 65px;
  min-width: 141px;
  border: 0.5px solid #a27726 !important;
  background-color: #ffffff !important;
  color: #a27726 !important;
  padding-top: 8px !important;
  border-radius: 75px 75px !important;
  transition: ease all 0.5s;
}
.nav-link.active {
  color: #ffffff !important;
  background-color: #cd0006 !important;
  border-color: #a27726 !important;
  font-weight: 900 !important;
  min-width: 141px;
  margin-left: -30px;
  transition: ease all 0.5s;
}
@media (max-width: 650px) {
  .hero {
    @include justify-content(flex-start);
    @include align-items(flex-start);
    height: 61.5vh;
    padding: 35px;
  }
  .hero--1 {
    background-size: 300% !important;
    background-position-x: center !important;
  }
  .buy-btn-hero {
    @include justify-content(center);
    @include flexbox();
    @include align-items(center);
    position: absolute;
    bottom: -15px;
    left: 35%;
    z-index: 10;
    display: block;
    max-width: 120px;
  }
  .hero-text-img {
    height: 550px !important;
    position: absolute !important;
    z-index: 0 !important;
    top: -110px !important;
    left: -175px !important;
  }
  .title {
    font-size: 50px;
    line-height: 40px;
  }
  .bottles {
    position: absolute;
    top: 10;
    top: 20px !important;
    height: 95%;
    right: 15px !important;
    z-index: -1;
  }
  img.golden-border {
    display: none !important;
  }
  .nav {
    @include flex-direction(column);
    position: absolute;
    @include justify-content(flex-start);
    left: -10px;
    width: 140px;
    bottom: 250px;
  }
  div.inline-nav__text--1 {
    margin-top: 0px !important;
  }
  .inline-nav__text--2 {
    margin-top: 0px !important;
  }
  .inline-nav__text--3 {
    margin-top: 0px !important;
  }
  .nav-link.active {
    margin-left: -60px !important;
  }
}
@media screen and (min-width: 650px) {
  .buy-btn-1 {
    display: none !important;
  }
}
@media (max-width: 445px) {
  // .hero {
  //   height: 74vh;
  // }
  .hero-text-img {
    height: 520px !important;
    top: -110px !important;
    left: -155px !important;
  }

  .nav {
    flex-direction: column;
    position: absolute;
    left: -10px;
    width: 140px;
    top: 240px;
    bottom: 30px;
    // bottom: 5px;
    // margin-bottom: -35px;
  }
  .hero--1 {
    background-size: 290% !important;
  }
  .hero--2 {
    background-position-x: -150px !important;
  }
  .hero--3 {
    background-position-x: -360px !important;
  }
}
@media (max-width: 428px) {
  .hero {
    height: 63vh;
  }
}
@media (max-width: 414px) {
  .hero {
    height: 70vh;
  }
  .nav {
    top: auto;
    bottom: 80px !important;
  }
  .nav-tabs .nav-link {
    min-height: 60px !important;
  }
  .hero-text-img {
    height: 495px !important;
    top: -110px !important;
    left: -145px !important;
  }
}
@media (max-width: 390px) {
  .hero {
    height: 63vh !important;
    margin-top: 70px !important;
  }
  .hero--1 {
    background-size: 290% !important;
  }
}
@media (max-width: 375px) {
  .hero {
    height: 66.7vh !important;
    margin-top: 0px !important;
    @media (max-width: 360px) {
      height: 70vh !important;
    }
  }
  .nav {
    top: auto;
    bottom: 80px !important;
    left: -30px;
  }
  .hero--1 {
    background-size: 250% !important;
  }
  .hero-text-img {
    height: 400px !important;
    top: -60px !important;
    left: -105px !important;
  }
  .nav-tabs .nav-link {
    min-height: 50px !important;
  }
  div.inline-nav__text {
    font-size: 13px !important;
    line-height: 13px !important;
  }
  .bottles {
    top: 55px !important;
    height: 85% !important;
  }
}
@media (max-width: 360px) {
  .hero {
    height: 70vh !important;
  }
  .hero--1 {
    background-size: 270% !important;
  }
  .hero-text-img {
    height: 375px !important;
    top: -55px !important;
    left: -75px !important;
  }
}
@media (min-height: 800px) {
  .hero {
    height: 69vh !important;
  }
}
@media (min-height: 880px) {
  .hero {
    height: 69vh !important;
  }
}
@-webkit-keyframes pulse {
  0% {
    opacity: 1;
    -ms-transform-origin-x: 0px;
  }

  50% {
    opacity: 1;
    -ms-transform-origin-x: 20px;
  }

  100% {
    opacity: 1;
    -ms-transform-origin-x: 0px;
  }
}
</style>
